// Constants
import { GetRoleKeys } from "../constants/rbac-roles"
const ROLES_KEYS = GetRoleKeys()

// Utils
import { extractUserIdentity } from "~utils/user"
import { getMemoryToken } from "~utils/auth-token"

const isCompanyRole = (): boolean => {
  const accessToken = getMemoryToken()
  if (!accessToken) return false
  const loggedUser = extractUserIdentity(accessToken)

  // Get user roles
  let roles: string[] = loggedUser.authorities.roles

  // If the user do not have ROLE ADMIN
  return roles.every(role => role !== ROLES_KEYS.ROLE_ADMIN)
}

export default isCompanyRole
